/* v-term：在某个容器上显式触发一次术语扫描。
 *
 * 一般用不到 —— GlossaryTip 挂载时已经对整个应用开了自动扫描
 * （utils/glossaryScan.js 的 MutationObserver）。
 *
 * 留这个指令是给两种情况用的：
 *
 *   1. 渲染在观察范围之外的东西（Teleport 到 body 的对话框、抽屉）
 *   2. 想在某个容器里**立刻**扫一遍，不等下一帧
 *
 * 扫描逻辑与自动扫描完全同源，同样只碰静态标签容器，同样幂等。
 */

import { scan } from '@/utils/glossaryScan'

function scanSoon(el) {
  scan(el)
  // Element Plus 的表头是它自己生命周期里渲染的，未必赶得上 mounted。
  // 用 setTimeout 而非 rAF：隐藏标签页里 rAF 不触发（见 glossaryScan.js）。
  setTimeout(() => scan(el), 0)
}

export const vTerm = {
  mounted: scanSoon,
  updated: scan,
}

export default vTerm
